import { gql } from "@apollo/client";

//#region DatosClinicos
export const GET_VISITA_DATO_CLINICO = gql`
  query visitaDatoClinico($idVisita: Int!, $idEvaluacion: Int!) {
    visitaDatoClinico(idVisita: $idVisita, idEvaluacion: $idEvaluacion) {
      idVisitaDatoClinico
      oncologico
      pesoActual
      talla
      justificacionVariacion
      idComboRIValorTiempo
      pesoHabitual
      idComboRIValorEvaluado
      iMC
      perdidaPeso
      idComboRIValorGradoDesnutricion
      idComboRIValorDiagnostico
      idComboRIValorSoporte
      zScoreTalla
      zScorePeso
      zScoreIMC
      idComboRIValorJustificacion
      causaJustificacion
      idComboRIValorFase
      justificacionModificacion
      alergias{
        idAlergia
        descripcionAlergia
        descripcionAlergiaOtro
      }
      diagnosticos {
        idDiagnosticoVisita
        idVisitaDatoClinico
        idDiagnostico
        idItemDiagnostico
        descripcionItemDiagnostico
        descripcionDiagnostico
      }
    }
  }
`;

export const adaptVisitaDatoClinicoModel = (m) => !m ? undefined : {
  idVisitaDatoClinico: m.idVisitaDatoClinico,
  oncologico: m.oncologico,
  pesoActual: m.pesoActual,
  prevPesoActual: m.pesoActual,
  talla: m.talla,
  justificacionVariacion: m.justificacionVariacion,
  idComboRIValorTiempo: m.idComboRIValorTiempo,
  pesoHabitual: m.pesoHabitual,
  idComboRIValorEvaluado: m.idComboRIValorEvaluado,
  iMC: m.iMC,
  perdidaPeso: m.perdidaPeso,
  idComboRIValorGradoDesnutricion: m.idComboRIValorGradoDesnutricion,
  idComboRIValorDiagnostico: m.idComboRIValorDiagnostico,
  idComboRIValorSoporte: m.idComboRIValorSoporte,
  zScoreTalla: m.zScoreTalla,
  zScorePeso: m.zScorePeso,
  zScoreIMC: m.zScoreIMC,
  idComboRIValorJustificacion: m.idComboRIValorJustificacion,
  causaJustificacion: m.causaJustificacion,
  idComboRIValorFase: m.idComboRIValorFase,
  prevFasePaciente: m.idComboRIValorFase,
  justificacionModificacionDatosClinicos: m.justificacionModificacion,
  alergiasDatosClinicos: m.alergias?.map((a) => a.idAlergia) || [],
  descripcionAlergiaOtro: m.alergias?.find((a) => a.descripcionAlergia?.toLowerCase() === 'otros')?.descripcionAlergiaOtro || '',
  listaDiagnostico: m?.diagnosticos?.map((x) => {
    return {
      codigoItem: x.idItemDiagnostico,
      codigo: x.idDiagnostico,
      descripcionItem: x.descripcionItemDiagnostico,
      descripcion: x.descripcionDiagnostico
    };
  }) || []
};


//#endregion

//#region Enteral

export const GET_VISITA_ENTERAL = gql`
  query visitaEnteral($idVisita: Int!, $idEvaluacion: Int!) {
    visitaEnteral(idVisita: $idVisita, idEvaluacion: $idEvaluacion) {
      idVisitaEnteral
      idComboRIValorKarnofsky
      ingestaOral
      idComboRIValorTipoAcceso
      cambioSNGoSOG
      justificacionCambioSNGoSOG
      accesoEnteral
      justificacionAccesoEnteral
      negativaGastrostomia
      justificacionNegativaGastrostomia
      justificacionModificacion
      idComboRIValorModoInfusion
      llevaBomba
      formaPreparacion
      indicacionEspecial
      flujo
      hidratacion
      indicacionHidratacion
      proteinasTotales
      caloriasTotales
      cambioSngDomicilio
      indicaciones {
        idIndicacionVisita
        idVisita
        idInsumo
        cantidadDiaria
        descripcion
        idUnidad
        descripcionUnidad
        fechaDesde
        fechaHasta
        proteinas
        calorias
      }
      complicaciones
    }
  }
`;


export const adaptVisitaEnteralModel = (m) => !m ? undefined : {
  idVisitaEnteral: m.idVisitaEnteral,
  idComboRIValorKarnofsky: m.idComboRIValorKarnofsky,
  ingestaOral: m.ingestaOral,
  idComboRIValorTipoAcceso: m.idComboRIValorTipoAcceso,
  cambioSNGoSOG: m.cambioSNGoSOG,
  justificacionCambioSNGoSOG: m.justificacionCambioSNGoSOG,
  accesoEnteral: m.accesoEnteral,
  justificacionAccesoEnteral: m.justificacionAccesoEnteral,
  negativaGastrostomia: m.negativaGastrostomia,
  justificacionNegativaGastrostomia: m.justificacionNegativaGastrostomia,
  justificacionModificacion: m.justificacionModificacion,
  idComboRIValorModoInfusion: m.idComboRIValorModoInfusion,
  llevaBomba: m.llevaBomba,
  formaPreparacion: m.formaPreparacion,
  indicacionEspecial: m.indicacionEspecial,
  flujo: m.flujo,
  hidratacion: m.hidratacion,
  indicacionHidratacion: m.indicacionHidratacion,
  proteinasTotales: m.proteinasTotales,
  caloriasTotales: m.caloriasTotales,
  cambioSngDomicilio: m.cambioSngDomicilio,
  listaIndicacion: m.indicaciones?.map((i) => ({
    idInsumo: i.idInsumo,
    nombreInsumo: i.descripcion,
    cantidadDiaria: i.cantidadDiaria,
    unidad: i.descripcionUnidad,
    proteinas: i.proteinas,
    calorias: i.calorias
  })) || [],
  complicaciones: m.complicaciones
};
//#endregion

//#region Parenteral

export const GET_VISITA_PARENTERAL = gql`
  query visitaParenteral($idVisita: Int!, $idEvaluacion: Int!) {
    visitaParenteral(idVisita: $idVisita, idEvaluacion: $idEvaluacion) {
      idVisitaParenteral
      idComboRIValorKarnofsky
      ingestaOral
      gERFormula
      idComboRIValorTipoCateter
      justificacionTransitorio
      fechaColocacion
      idComboRIValorUbicacionCateter
      idComboRIValorLumenes
      insercionNormal
      justificacionInsercion
      idComboRIValorModoInfusion
      justificacionModificacion
      idComboRIValorSellado
      cantidadHorasMagistral
      flujoMagistral
      cantidadHorasEstandar
      flujoEstandar
      cantidadEscalonesMagistral
      duracionMesetaMagistral
      cicloMagistral
      cantidadEscalonesEstandar
      duracionMesetaEstandar
      cicloEstandar
      expansion
      idComboVisitaValorProducto
      volumen
      idComboVisitaValorExpansion
      flujo
      indicacionComentario
      indicacionEspecial
      calorias
      hidratosCarbono
      proteinas
      lipidos
      proteinasTotales
      lipidosTotales
      caloriasTotales
      idIndicacionVisitaBAP
      bAPMagistral
      volumenMagistral
      bAPEstandar
      volumenEstandar
      idInsumo
      idComboRIValorMotivoEstandar
      idComboRIValorMotivoMagistral
      diasConexion {
        dia
        idComboRIValorTipoBAP
      }
      complicaciones
    }
  }
`;



export const adaptVisitaParenteralModel = (m) => !m ? undefined : {
  idVisitaParenteral: m.idVisitaParenteral,
  idComboRIValorKarnofsky: m.idComboRIValorKarnofsky,
  ingestaOral: m.ingestaOral,
  gERFormula: m.gERFormula,
  idComboRIValorTipoCateter: m.idComboRIValorTipoCateter,
  justificacionTransitorio: m.justificacionTransitorio,
  fechaColocacion: m.fechaColocacion,
  idComboRIValorUbicacionCateter: m.idComboRIValorUbicacionCateter,
  idComboRIValorLumenes: m.idComboRIValorLumenes,
  insercionNormal: m.insercionNormal,
  justificacionInsercion: m.justificacionInsercion,
  idComboRIValorModoInfusion: m.idComboRIValorModoInfusion,
  justificacionModificacion: m.justificacionModificacion,
  idComboRIValorSellado: m.idComboRIValorSellado,
  cantidadHorasMagistral: m.cantidadHorasMagistral || 24,
  flujoMagistral: m.flujoMagistral,
  cantidadHorasEstandar: m.cantidadHorasEstandar || 24,
  flujoEstandar: m.flujoEstandar,
  cantidadEscalonesMagistral: m.cantidadEscalonesMagistral,
  duracionMesetaMagistral: m.duracionMesetaMagistral,
  cicloMagistral: m.cicloMagistral,
  cantidadEscalonesEstandar: m.cantidadEscalonesEstandar,
  duracionMesetaEstandar: m.duracionMesetaEstandar,
  cicloEstandar: m.cicloEstandar,
  expansion: m.expansion,
  idComboVisitaValorProducto: m.idComboVisitaValorProducto,
  volumen: m.volumen,
  idComboVisitaValorExpansion: m.idComboVisitaValorExpansion,
  flujo: m.flujo,
  indicacionComentario: m.indicacionComentario,
  indicacionEspecial: m.indicacionEspecial,
  calorias: m.calorias,
  hidratosCarbono: m.hidratosCarbono,
  proteinas: m.proteinas,
  lipidos: m.lipidos,
  proteinasTotales: m.proteinasTotales,
  lipidosTotales: m.lipidosTotales,
  caloriasTotales: m.caloriasTotales,
  idIndicacionVisitaBAP: m.idIndicacionVisitaBAP,
  bAPMagistral: m.bAPMagistral,
  volumenMagistral: m.volumenMagistral,
  bAPEstandar: m.bAPEstandar,
  volumenEstandar: m.volumenEstandar,
  idInsumo: m.idInsumo,
  idComboRIValorMotivoEstandar: m.idComboRIValorMotivoEstandar,
  idComboRIValorMotivoMagistral: m.idComboRIValorMotivoMagistral,
  diasConexion: m.diasConexion?.map((d) => ({ dia: d.dia, idComboRIValorTipoBAP: d.idComboRIValorTipoBAP })) ?? [],
  complicaciones: m.complicaciones,
  // Conveniencia para reusar en inputs:
  indicacionVisitaBAP: {
    bAPMagistral: !!m.bAPMagistral,
    volumenMagistral: m.volumenMagistral,
    bAPEstandar: !!m.bAPEstandar,
    volumenEstandar: m.volumenEstandar,
    idInsumo: m.idInsumo,
    idComboRIValorMotivoEstandar: m.idComboRIValorMotivoEstandar,
    idComboRIValorMotivoMagistral: m.idComboRIValorMotivoMagistral
  }
};
//#endregion
//#region NPID

export const GET_VISITA_NPID = gql`
  query visitaNpid($idVisita: Int!, $idEvaluacion: Int!) {
    visitaNpid(idVisita: $idVisita, idEvaluacion: $idEvaluacion) {
      idVisitaNpid
      idComboRIValorAcceso
      fechaColocacion
      idComboRIValorUbicacion
      idComboRIValorLumenes
      insercionNormal
      justificacionInsercion
      indicacionComentario
      proteinasTotales
      lipidosTotales
      caloriasTotales
      ingestaOral
      suplementoOral
      idIndicacionVisitaBAP
      requerimientoCalorico
      dietaConvencional
      bAPMagistral
      volumenMagistral
      bAPEstandar
      volumenEstandar
      idInsumo
      idComboRIValorMotivoEstandar
      idComboRIValorMotivoMagistral
      diasConexion {
        dia
        idComboRIValorTipoBAP
      }
      complicaciones
    }
  }
`;
export const adaptVisitaNpidModel = (m) => !m ? undefined : {
  idVisitaNpid: m.idVisitaNpid,
  idComboRIValorAcceso: m.idComboRIValorAcceso,
  fechaColocacion: m.fechaColocacion,
  idComboRIValorUbicacion: m.idComboRIValorUbicacion,
  idComboRIValorLumenes: m.idComboRIValorLumenes,
  insercionNormal: m.insercionNormal, // en modelo es int?, lo dejamos tal cual (0/1/null)
  justificacionInsercion: m.justificacionInsercion,
  indicacionComentario: m.indicacionComentario,
  proteinasTotales: m.proteinasTotales,
  lipidosTotales: m.lipidosTotales,
  caloriasTotales: m.caloriasTotales,
  ingestaOral: m.ingestaOral,
  suplementoOral: m.suplementoOral,
  idIndicacionVisitaBAP: m.idIndicacionVisitaBAP,
  requerimientoCalorico: m.requerimientoCalorico,
  dietaConvencional: m.dietaConvencional,
  bAPMagistral: m.bAPMagistral,
  volumenMagistral: m.volumenMagistral,
  bAPEstandar: m.bAPEstandar,
  volumenEstandar: m.volumenEstandar,
  idInsumo: m.idInsumo,
  idComboRIValorMotivoEstandar: m.idComboRIValorMotivoEstandar,
  idComboRIValorMotivoMagistral: m.idComboRIValorMotivoMagistral,
  diasConexion: m.diasConexion?.map((d) => ({ dia: d.dia, idComboRIValorTipoBAP: d.idComboRIValorTipoBAP })) ?? [],
  complicaciones: m.complicaciones,
  // Conveniencia para inputs
  indicacionVisitaBAP: {
    bAPMagistral: !!m.bAPMagistral,
    volumenMagistral: m.volumenMagistral,
    bAPEstandar: !!m.bAPEstandar,
    volumenEstandar: m.volumenEstandar,
    idInsumo: m.idInsumo,
    idComboRIValorMotivoEstandar: m.idComboRIValorMotivoEstandar,
    idComboRIValorMotivoMagistral: m.idComboRIValorMotivoMagistral
  }
};

//#endregion

//#region Oral
export const GET_VISITA_ORAL = gql`
  query visitaOral($idVisita: Int!, $idEvaluacion: Int!) {
    visitaOral(idVisita: $idVisita, idEvaluacion: $idEvaluacion) {
      idVisitaOral
      idComboRIValorKarnofsky
      justificacionModificacion
      indicacionComentario
      caloricoTotal
      caloricoSO
      porcentajeSO
      idVisita
      indicaciones {
        idIndicacionVisita
        idVisita
        idInsumo
        cantidadDiaria
        descripcion
        idUnidad
        descripcionUnidad
        fechaDesde
        fechaHasta
        proteinas
        calorias
      }
      complicaciones
    }
  }
`;


export const adaptVisitaOralModel = (m) => !m ? undefined : {
  idVisitaOral: m.idVisitaOral,
  idComboRIValorKarnofsky: m.idComboRIValorKarnofsky,
  justificacionModificacion: m.justificacionModificacion,
  indicacionComentario: m.indicacionComentario,
  caloricoTotal: m.caloricoTotal,
  caloricoSO: m.caloricoSO,
  porcentajeSO: m.porcentajeSO,
  listaIndicacion: m.indicaciones?.map((i) => ({
    idInsumo: i.idInsumo,
    nombreInsumo: i.descripcion,
    cantidadDiaria: i.cantidadDiaria,
    unidad: i.descripcionUnidad,
    proteinas: i.proteinas,
    calorias: i.calorias
  })) || [],
  complicaciones: m.complicaciones
};

//#endregion

//#region KETO
export const GET_VISITA_KETO = gql`
  query visitaKeto($idVisita: Int!, $idEvaluacion: Int!) {
    visitaKeto(idVisita: $idVisita, idEvaluacion: $idEvaluacion) {
      idVisitaKeto
      idComboRIValorEstadio
      fG
      justificacionModificacion
      indicacionComentario
      mismoRequerimiento
      calorica
      proteica
      fosforo
      potasio
      sodio
      cantidad
      indicaciones {
        idIndicacionVisita
        idVisita
        idInsumo
        cantidadDiaria
        descripcion
        idUnidad
        descripcionUnidad
        fechaDesde
        fechaHasta
        proteinas
        calorias
      }
      complicaciones
    }
  }
`;

export const adaptVisitaKetoModel = (m) => !m ? undefined : {
  idVisitaKeto: m.idVisitaKeto,
  idComboRIValorEstadio: m.idComboRIValorEstadio,
  fG: m.fG,
  justificacionModificacion: m.justificacionModificacion,
  indicacionComentario: m.indicacionComentario,
  mismoRequerimiento: m.mismoRequerimiento,
  calorica: m.calorica,
  proteica: m.proteica,
  fosforo: m.fosforo,
  potasio: m.potasio,
  sodio: m.sodio,
  cantidad: m.cantidad,
  listaIndicacion: m.indicaciones?.map((i) => ({
    idInsumo: i.idInsumo,
    nombreInsumo: i.descripcion,
    cantidadDiaria: i.cantidadDiaria,
    unidad: i.descripcionUnidad,
    proteinas: i.proteinas,
    calorias: i.calorias
  })) || [],
  complicaciones: m.complicaciones
};

//#endregion

//#region CEAO
export const GET_VISITA_CEAO = gql`
  query visitaCeao($idVisita: Int!, $idEvaluacion: Int!) {
    visitaCeao(idVisita: $idVisita, idEvaluacion: $idEvaluacion) {
      idVisitaCeao
      justificacionModificacion
      indicacionComentario
      suplementoVitaminico
      suplemento
      indicacionSuplemento
      caloriasTotales
      caloriasSO
      porcentajeSO
      cantidadAnticonvulsivante
      medicacionAnticonvulsivante
      cetonemia
      resultadoCetonemia
      cetonuria
      resultadoCetonuria
      cantidadCrisis
      observacion
      indicaciones {
        idIndicacionVisita
        idVisita
        idInsumo
        cantidadDiaria
        descripcion
        idUnidad
        descripcionUnidad
        fechaDesde
        fechaHasta
        proteinas
        calorias
      }
      complicaciones
    }
  }
`;
export const adaptVisitaCeaoModel = (m) => !m ? undefined : {
  idVisitaCeao: m.idVisitaCeao,
  justificacionModificacion: m.justificacionModificacion,
  indicacionComentario: m.indicacionComentario,
  suplementoVitaminico: m.suplementoVitaminico,
  suplemento: m.suplemento,
  indicacionSuplemento: m.indicacionSuplemento,
  caloriasTotales: m.caloriasTotales,
  caloriasSO: m.caloriasSO,
  porcentajeSO: m.porcentajeSO,
  cantidadAnticonvulsivante: m.cantidadAnticonvulsivante,
  medicacionAnticonvulsivante: m.medicacionAnticonvulsivante,
  cetonemia: m.cetonemia,
  resultadoCetonemia: m.resultadoCetonemia,
  cetonuria: m.cetonuria,
  resultadoCetonuria: m.resultadoCetonuria,
  cantidadCrisis: m.cantidadCrisis,
  observacion: m.observacion,
  listaIndicacion: m.indicaciones?.map((i) => ({
    idInsumo: i.idInsumo,
    nombreInsumo: i.descripcion,
    cantidadDiaria: i.cantidadDiaria,
    unidad: i.descripcionUnidad,
    proteinas: i.proteinas,
    calorias: i.calorias
  })) || [],
  complicaciones: m.complicaciones
};

//#endregion

//#region CEAE
export const GET_VISITA_CEAE = gql`
  query visitaCeae($idVisita: Int!, $idEvaluacion: Int!) {
    visitaCeae(idVisita: $idVisita, idEvaluacion: $idEvaluacion) {
      idVisitaCeae
      ingestaOral
      idComboRIValorAcceso
      cambioSNG
      justificaCambio
      accesoEnteral
      justificaAccesoEnteral
      negativaGastrostomia
      justificaGastrostomia
      justificacionModificacion
      idComboRIValorModoInfusion
      llevaBomba
      formaPreparacion
      indicacionEspecial
      flujo
      hidratacion
      indicacionHidratacion
      suplementoVitaminico
      suplemento
      indicacionSuplemento
      proteinasTotales
      caloriasTotales
      cantidadAnticonvulsivante
      medicacionAnticonvulsivante
      cetonemia
      resultadoCetonemia
      cetonuria
      resultadoCetonuria
      cantidadCrisis
      observacion
      indicacionComentario
      caloriasSO
      porcentajeSO
      indicaciones {
        idIndicacionVisita
        idVisita
        idInsumo
        cantidadDiaria
        descripcion
        idUnidad
        descripcionUnidad
        fechaDesde
        fechaHasta
        proteinas
        calorias
      }
      complicaciones
    }
  }
`;


export const adaptVisitaCeaeModel = (m) => !m ? undefined : {
  idVisitaCeae: m.idVisitaCeae,
  ingestaOral: m.ingestaOral,
  idComboRIValorTipoAcceso: m.idComboRIValorAcceso,
  cambioSNG: m.cambioSNG,
  justificaCambio: m.justificaCambio,
  accesoEnteral: m.accesoEnteral,
  justificaAccesoEnteral: m.justificaAccesoEnteral,
  negativaGastrostomia: m.negativaGastrostomia,
  justificaGastrostomia: m.justificaGastrostomia,
  justificacionModificacion: m.justificacionModificacion,
  idComboRIValorModoInfusion: m.idComboRIValorModoInfusion,
  llevaBomba: m.llevaBomba,
  formaPreparacion: m.formaPreparacion,
  indicacionEspecial: m.indicacionEspecial,
  flujo: m.flujo,
  hidratacion: m.hidratacion,
  indicacionHidratacion: m.indicacionHidratacion,
  suplementoVitaminico: m.suplementoVitaminico,
  suplemento: m.suplemento,
  indicacionSuplemento: m.indicacionSuplemento,
  proteinasTotales: m.proteinasTotales,
  caloriasTotales: m.caloriasTotales,
  cantidadAnticonvulsivante: m.cantidadAnticonvulsivante,
  medicacionAnticonvulsivante: m.medicacionAnticonvulsivante,
  cetonemia: m.cetonemia,
  resultadoCetonemia: m.resultadoCetonemia,
  cetonuria: m.cetonuria,
  resultadoCetonuria: m.resultadoCetonuria,
  cantidadCrisis: m.cantidadCrisis,
  observacion: m.observacion,
  indicacionComentario: m.indicacionComentario,
  caloriasSO: m.caloriasSO,
  porcentajeSO: m.porcentajeSO,
  listaIndicacion: m.indicaciones?.map((i) => ({
    idInsumo: i.idInsumo,
    nombreInsumo: i.descripcion,
    cantidadDiaria: i.cantidadDiaria,
    unidad: i.descripcionUnidad,
    proteinas: i.proteinas,
    calorias: i.calorias
  })) || [],
  complicaciones: m.complicaciones
};

//#endregion

//#region DISFAGIA
export const GET_VISITA_DISFAGIA = gql`
  query visitaDisfagia($idVisita: Int!, $idEvaluacion: Int!) {
    visitaDisfagia(idVisita: $idVisita, idEvaluacion: $idEvaluacion) {
      idVisitaDisfagia
      videodeglucion
      disfagiaADisfagia{
        idDisfagiaADisfagia
        idComboRIValor
      }
      neumonia
      disfagiaAlimentacion{
        idDisfagiaAlimentacion
        idComboRIValor
      }
      disfagiaHidratacion{
        idDisfagiaHidratacion
        idComboRIValor
      }
      traqueostomia
      lucido
      compromisoMotor
      justificacionModificacion
      formaPreparacion
      indicacionEspecial
      hidratacion
      indicacionHidratacion
      proteinasTotales
      caloriasTotales
      actividadMotora
      controlCefalico
      idComboRIValorPostural
      idComboRIValorDenticion
      idComboRIValorProtesis
      nadaPorBoca
      justificaNadaPorBoca
      idComboVisitaValorTipoDieta
      indicaciones {
        idIndicacionVisita
        idVisita
        idInsumo
        cantidadDiaria
        descripcion
        idUnidad
        descripcionUnidad
        fechaDesde
        fechaHasta
        proteinas
        calorias
      }
      complicaciones
      indicacion
      idComboVisitaValorTipoRehabilitacion
      examenClinico
      maniobrasPosturales
      idComboRIValorHidratacion
    }
  }
`;

export const adaptVisitaDisfagiaModel = (m) => !m ? undefined : {
  idVisitaDisfagia: m.idVisitaDisfagia,
  videodeglucion: m.videodeglucion,
  disfagias: m.disfagiaADisfagia?.map((d) => d.idComboRIValor),
  neumonia: m.neumonia,
  alimentos: m.disfagiaAlimentacion?.map((d) => d.idComboRIValor),
  hidrataciones: m.disfagiaHidratacion?.map((d) => d.idComboRIValor),
  traqueostomia: m.traqueostomia,
  lucido: m.lucido,
  compromisoMotor: m.compromisoMotor,
  justificacionModificacion: m.justificacionModificacion,
  formaPreparacion: m.formaPreparacion,
  indicacionEspecial: m.indicacionEspecial,
  hidratacion: m.hidratacion,
  indicacionHidratacion: m.indicacionHidratacion,
  proteinasTotales: m.proteinasTotales,
  caloriasTotales: m.caloriasTotales,
  actividadMotora: m.actividadMotora,
  controlCefalico: m.controlCefalico,
  idComboRIValorPostural: m.idComboRIValorPostural,
  idComboRIValorDenticion: m.idComboRIValorDenticion,
  idComboRIValorProtesis: m.idComboRIValorProtesis,
  nadaPorBoca: m.nadaPorBoca,
  justificaNadaPorBoca: m.justificaNadaPorBoca,
  idComboVisitaValorTipoDieta: m.idComboVisitaValorTipoDieta,
  listaIndicacion: m.indicaciones?.map((i) => ({
    idInsumo: i.idInsumo,
    nombreInsumo: i.descripcion,
    cantidadDiaria: i.cantidadDiaria,
    unidad: i.descripcionUnidad,
    proteinas: i.proteinas,
    calorias: i.calorias
  })) || [],
  complicaciones: m.complicaciones
};



export const adaptVisitaDisfagiaFonoModel = (m) => !m ? undefined : {
  idVisitaDisfagia: m.idVisitaDisfagia,
  videodeglucion: m.videodeglucion,
  actividadMotora: m.actividadMotora,
  controlCefalico: m.controlCefalico,
  idComboRIValorPostural: m.idComboRIValorPostural,
  idComboRIValorDenticion: m.idComboRIValorDenticion,
  idComboRIValorProtesis: m.idComboRIValorProtesis,
  nadaPorBoca: m.nadaPorBoca,
  justificaNadaPorBoca: m.justificaNadaPorBoca,
  idComboVisitaValorTipoDieta: m.idComboVisitaValorTipoDieta,
  idComboRIValorHidratacion: m.idComboRIValorHidratacion,
  complicaciones: m.complicaciones,
  indicacion: m.indicacion,
  idComboVisitaValorTipoRehabilitacion: m.idComboVisitaValorTipoRehabilitacion,
  examenClinico: m.examenClinico,
  maniobrasPosturales: m.maniobrasPosturales
};
//#endregion

//#region HE
export const GET_VISITA_HE = gql`
  query visitaHe($idVisita: Int!) {
    visitaHe(idVisita: $idVisita) {
      idVisitaHe
      idComboRIValorSellado
      indicacionComentario
    }
  }
`;


export const adaptVisitaHeModel = (m) => !m ? undefined : {
  idVisitaHe: m.idVisitaHe,
  idComboRIValorSellado: m.idComboRIValorSellado,
  indicacionComentario: m.indicacionComentario
};
//#endregion